const DEFAULT_EVENTS_NAME = ['click', 'mouseover', 'mouseout']


/**
 *
 * @desc 首字母大写
 * @param {*} str
 * @return {*}
 */
function capitalizeFirstLetter(str) {
  // 确保输入不为空
  if (typeof str !== 'string' || str.length === 0) {
    return str
  }

  // 将首字母转为大写并与剩余部分拼接
  return str.charAt(0).toUpperCase() + str.slice(1)
}

/**
 *
 * @desc 'a-b-c' 转驼峰 'aBC'
 * @param {*} inputString
 * @return {*}
 */
function processHumpString(inputString) {
  // 使用正则表达式将字符串按照 "-" 分割成数组
  const parts = inputString.split('-')

  // 如果数组长度小于等于1，无需处理
  if (parts.length <= 1) {
    return inputString
  }

  // 将除第一个部分外的其他部分的首字母大写
  const processedParts = parts.slice(1).map(part => part.charAt(0).toUpperCase() + part.slice(1))

  // 返回结果：第一个部分 + 处理后的其他部分拼接而成的字符串
  return parts[0] + processedParts.join('')
}

/**
 *
 * @desc 获取事件集合
 * @param {*} [eventsName=[]]
 * @return {*}
 */
function parseEventsName (eventsName = [], ignoreEventName = []) {
  try {
    const events = [...new Set([...DEFAULT_EVENTS_NAME, ...eventsName])]
    // 排除忽略的事件。历史设计原因
    const activeEvents = events.reduce((pre, name) => {
      if (!ignoreEventName.includes(name)) {
        pre.push(name)
      }
      return pre
    }, [])
    return activeEvents
  } catch (error) {
    console.error('[queryTable-parseEventsName]', error)
    return null
  }
}

/**
 *
 * @desc 监听事件，执行指令回调
 * @param {*} {subEventsNameList, handler, args, el}
 */
function addEventListenerName ({subEventsNameList = [], handler, args, el}) {
  subEventsNameList.forEach(name => {
    el.addEventListener(name, (e) => {
      handler({name, el, args})
    })
  })
}

const directives = {
  events: {
    // 指令的定义
    bind: function (el, binding, vnode) {
      try {
        const { eventsMap, args, ignoreEventName } = binding.value
        const { handler, subEventsName } = eventsMap
        const subEventsNameList = parseEventsName(subEventsName, ignoreEventName)
        // 事件监听
        addEventListenerName({
          subEventsNameList,
          handler,
          args,
          el
        })
      } catch (error) {
        console.info(error)
      }
    }
  }
}
export default {
  props: {
    // 用户订阅的卡片监听事件
    subEventsName: {
      type: Array,
      default: () => []
    },
    // 气泡的配置props
    cardPopoverProps: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      reference: null,
      renderCardName: null,
      ignoreEventName: ['click']
    }
  },
  computed: {
    // 指令入参 执行的句柄，用户需要监听的事件名
    eventsMap () {
      const subEventsName = this.subEventsName
      const handler = this.handlerEvent
      return {
        handler,
        subEventsName,
      }
    },
    // 气泡组件集合。内含用户配置
    popoverConfig () {
      const usePopConfig = this.$props.cardPopoverProps[this.renderCardName] || {
        placement: 'top',
        width: 'auto'
      }
      // reference 指定气泡的载体 renderCardName 当前挂载的位置
      const { reference, renderCardName } = this
      return Object.assign({}, usePopConfig, {
        reference,
        renderCardName
      })
    },
    // 气泡的动态插槽名称
    cardPopoverSlotName () {
      return this.renderCardName + 'Tooltip'
    }
  },
  directives,
  methods: {
    // 触发监听的事件
    handlerEvent ({name, args, el}) {
      try {
        const [prefixEventName] = args
        const eventName = prefixEventName + capitalizeFirstLetter(processHumpString(name))
        const val = args.slice(1)
        val.push(el)
        this.$emit(eventName, ...val)
        this.updatePopperInstance({name, prefixEventName, el})
      } catch (error) {
        console.info(error)
      }
    },
    // 更新气泡
    updatePopperInstance ({name, prefixEventName, el}) {
      if (name === 'mouseover') {
        this.renderCardName = null
        this.$nextTick(() => {
          this.reference = el
          this.renderCardName = prefixEventName
          if (this.$refs.popover) {
            this.$refs.popover.referenceElm = el
            this.$refs.popover.createPopper()
            this.$refs.popover.updatePopper()
          }
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-report-form/mixins/card-event-popover.js